/* ========================================================================== *\
    Imports
/* ========================================================================== */
import { isElement, forEach, reverse } from 'lodash';

import { publish, subscribe } from '../2-utilities/event';
import { isDesktop } from '../2-utilities/breakpoint';
import {
    MARKERS_PLACED as markersPlaced,
    STOP_MARKERS_POPUP as stopMarkersPopup,
    ROW_HOVER,
    ROW_OUT,
    ROW_CLICKED,
    SEARCH_ENTERED
} from '../3-data/consts/eventNames';

/* ========================================================================== *\
    Constants
/* ========================================================================== */
const moduleName = 'marker',
    baseSelector = `.js-${moduleName}`,
    hoverSelector = `${baseSelector}.--hover`;

let intervalVar,
    currentIndex = 0;

/* ========================================================================== *\
    Functionality
/* ========================================================================== */
function stop() {
    const els = document.querySelectorAll(baseSelector);

    forEach(els, el => {
        if (el.classList.contains('--hover')) {
            el.classList.remove('--hover');
        }
    });

    if (intervalVar) {
        clearTimeout(intervalVar);
    }
}

function showDetailAfterSearch({ detail }) {
    const { marker } = detail,
        elements = document.querySelectorAll(baseSelector),
        element = marker;

    if (isElement(element)) {
        forEach(elements, el => {
            el.classList.remove('--hover');
            el.classList.remove('--active');
            el.querySelector('.c-detail-popup').classList.add('--hide');
        });

        const coords = JSON.parse(element.getAttribute('data-coords'));

        element.classList.add('--active');
        element.querySelector('.c-detail-popup').classList.remove('--hide');

        publish('mapSetCenter', coords);
    }
}

function showDetailPopup({ detail }) {
    const { index } = detail,
        elements = document.querySelectorAll(baseSelector),
        element = elements[index];

    if (isElement(element)) {
        forEach(elements, el => {
            el.classList.remove('--hover');
            el.classList.remove('--active');
            el.querySelector('.c-detail-popup').classList.add('--hide');
        });

        const coords = JSON.parse(element.getAttribute('data-coords'));

        element.classList.add('--active');
        element.querySelector('.c-detail-popup').classList.remove('--hide');

        publish('mapSetCenter', coords);
    }
}

function hidePopup() {
    const elements = document.querySelectorAll(baseSelector);

    forEach(elements, el => {
        el.classList.remove('--hover');
    })
}

function showPopup({ detail }) {
    const { index } = detail,
        elements = document.querySelectorAll(baseSelector),
        element = elements[index];

    if (isElement(element)) {
        forEach(elements, el => {
            el.classList.remove('--hover');
        })

        element.classList.add('--hover');
    }
}


function init(baseElements) {
    const elArray = [].slice.call(baseElements),
        elements = reverse(elArray),
        length = elements.length;

    if (intervalVar) {
        clearTimeout(intervalVar);
    }

    let previousIndex = -1,
        index = 0;

    function interval() {
        if (previousIndex > -1 && isElement(elements[previousIndex])) {
            elements[previousIndex].classList.remove('--hover');
        }

        if (isElement(elements[index])) {
            elements[index].classList.add('--hover');
        } else {
            console.error('This element doesn\'t exist', index);
        }

        previousIndex = index;

        index++;

        if (index >= length) {
            index = 0;
        }

        intervalVar = setTimeout(interval, 2000);
    }

    if (isDesktop()) {
        intervalVar = setTimeout(interval, 500);
    }
}

subscribe(markersPlaced, () => init(document.querySelectorAll(baseSelector)));
subscribe(stopMarkersPopup, stop);

subscribe(ROW_OUT, hidePopup);
subscribe(ROW_HOVER, showPopup);
subscribe(ROW_CLICKED, showDetailPopup);
subscribe(SEARCH_ENTERED, showDetailAfterSearch);